module.exports = __webpack_public_path__ + "static/media/pancreas2019.3ed265b7.jpg";